(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-image-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const watched = new WeakSet();
  const selector = '.product-card--contained .product-featured-image-link img, [data-product-image-frame] img';
  const inspect = (image) => {
    if (image.classList.contains('product-image--studio-white')) return;
    if (!image.complete || image.naturalWidth < 32 || !image.naturalHeight) return;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 48;
      canvas.height = 48;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      context.drawImage(image, 0, 0, 48, 48);
      const pixels = context.getImageData(0, 0, 48, 48).data;
      let white = 0;
      let checked = 0;
      for (let y = 0; y < 48; y += 1) {
        for (let x = 0; x < 48; x += 1) {
          if (x > 1 && x < 46 && y > 1 && y < 46) continue;
          const offset = (y * 48 + x) * 4;
          checked += 1;
          if (pixels[offset + 3] > 250 && pixels[offset] >= 248 && pixels[offset + 1] >= 248 && pixels[offset + 2] >= 248) white += 1;
        }
      }
      image.classList.toggle('product-image--white-background', white / checked >= 0.80);
    } catch {
      image.classList.remove('product-image--white-background');
    }
  };
  const watch = (image) => {
    if (watched.has(image)) return;
    watched.add(image);
    image.addEventListener('load', () => inspect(image));
    inspect(image);
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) watch(root);
    root.querySelectorAll(selector).forEach(watch);
  };
  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
